import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4l7cxmmbqd: FaireBrandEntity = {
  token: "b_4l7cxmmbqd",
  type: "brand",
  name: "PANIER DES SENS",
  avatarUrl:
    "https://cdn.faire.com/fastly/7ea599ad96841136e0c4096be19498be220afa53cc6604137144c29077ac2242.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/40c124a33ae45c02f0f6ab9d0ab3799a7e3115195870fdc0341262f6750ec309.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7ea599ad96841136e0c4096be19498be220afa53cc6604137144c29077ac2242.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/40c124a33ae45c02f0f6ab9d0ab3799a7e3115195870fdc0341262f6750ec309.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 63,
  isTopShop: true,
  isInsider: true,
  description:
    "Born in Marseille, the capital of Provence, and nurtured from an early age in the gentle lifestyle of Provence, Jerome Lambruschini grew up in the shade of the cypress trees and mimosas of the Southern Alps region. \nIt's in the South of France, in the heart of Provence, that Panier des Sens was born in 2001. Inspired by natural resources and Mediterranean know-how, Panier des Sens takes the best that Provence has to offer to develop natural, simple and authentic products. Panier des Sens has been developing for almost 20 years its product skills with the masters soap makers from Marseille and perfumers from Grasse.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:25.728Z",
    importedBy: "entity-db-cli",
  },
};
